<template>
  <div class="add-group-input-wrapper">
    <el-input
      ref="input"
      v-model="groupName"
      :maxlength="8"
      placeholder="请输入分组名称"
      size="mini"
      @blur="handleBlur"
      @keyup.enter.native="handleEnter">
      <i slot="suffix"
         class="el-icon-circle-close"
         style="cursor: pointer; line-height: 28px; font-size: 14px;"
         v-if="groupName"
         @mousedown.prevent="handleClearClick"/>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'AddGroupInput',
  data() {
    return {
      groupName: '',
      loading: false,
      isClearing: false,
      isSaved: false
    }
  },
  methods: {
    // 聚焦输入框
    focus() {
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus()
        }
      })
    },
    // 失焦处理
    handleBlur() {
      // 如果是清除操作导致的失焦，不处理
      if (this.isSaved) return
      if (this.isClearing) {
        this.isClearing = false
        return
      }
      this.saveOrCancel()
    },
    // 回车处理
    handleEnter() {
      if (this.isSaved) return
      this.saveOrCancel()
    },
    // 保存或取消
    async saveOrCancel() {
      if (this.loading) return
      this.isSaved = true
      const trimmedName = this.groupName.trim()
      if (!trimmedName) {
        // 无内容，触发取消
        this.$emit('cancel')
        return
      }
      // 有内容，执行保存
      // if (this.loading) return
      try {
        this.loading = true
        // this.$emit('update:loading', true)
        const params = {
          userId: this.$store.state.user.id,
          groupName: trimmedName
        }
        await this.$http('system.homeModuleGroup.save', params)
        this.$message.success('保存成功')
        // 通知父组件重新加载列表
        this.$emit('saved')
        // 触发全局更新事件，通知 common-module-list 刷新
        this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
      } catch (error) {
        this.isSaved = false
        this.$refs.input && this.$refs.input.focus()
        console.error(error)
        // this.$message.error('保存失败')
      } finally {
        this.loading = false
        // this.$emit('update:loading', false)
      }
    },
    handleClearClick() {
      // this.isClearing = true
      // 清空输入值
      this.groupName = ''
      // 保持焦点在输入框
      this.$nextTick(() => {
        this.$refs.input && this.$refs.input.focus()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-group-input-wrapper {
  padding: 0 8px;
  margin-bottom: 6px;
  /deep/ .el-input__inner {
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/sider/add-group-input.vue